




















import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'NavigationTabs',
  props: {
    tabs: Array,
  },
  setup() {
    const tabsElement = ref(null)

    const updateSlider = () => {
      tabsElement.value.callSlider()
    }
    return { tabsElement, updateSlider }
  },
})
